<template>
  <div class="search-field form-input">
    <input
      ref="inputDom"
      type="search"
      placeholder="Chercher"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      @keydown.shift.tab="$emit('close-menu')"
    />
    <span class="icon">
      <i class="fa-regular fa-magnifying-glass"></i>
    </span>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: "sm",
    validator: (value) => ["sm", "md"].includes(value),
  },
});
defineEmits(["update:modelValue", "close-menu"]);

const inputDom = ref(null);

onMounted(() => inputDom.value.focus());
</script>

<style lang="scss" scoped>
.form-input {
  input {
    border: 1px solid var(--clr-p2);
    border-radius: 10px;

    &::placeholder {
      color: var(--clr-n8);
    }
  }
  .fa-magnifying-glass {
    color: var(--clr-n8);
  }
}

.search-field {
  position: relative;
  min-width: 200px;
  display: flex;
  align-items: center;

  input {
    width: 100%;
    height: v-bind("size === 'sm' ? '30px' : '36px'");
    padding: 4px 0 3px 15px;
    background: white;

    &:focus::placeholder {
      color: transparent;
    }

    &:focus {
      border: 2px solid var(--clr-p4);
    }
  }

  .icon {
    position: absolute;
    right: 5%;

    .fa-magnifying-glass {
      cursor: pointer;
    }
  }
}

/* clears the ‘X’ from Internet Explorer */
input[type="search"]::-ms-clear,
input[type="search"]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the ‘X’ from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
</style>
